import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const DialogFirst = ({
  open,
  onClose,
  title,
  children,
  actions,
  dialogWidth = "sm",
}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="Dialog-first"
      fullWidth
      maxWidth={dialogWidth}
      fullScreen={fullScreen}
    >
      <DialogTitle id="Dialog-first" sx={{py: 1}}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {children}
        </DialogContentText>
      </DialogContent>
        {actions && actions}
    </Dialog>
  );
};

export default DialogFirst;
